import { createContext } from 'react';

// Keep in sync with I18nRepository.SupportedLanguages in the API repo.
export const SUPPORTED_LANGS = ['se', 'gb', 'fi', 'no', 'dk', 'es'] as const;
export type LangCode = (typeof SUPPORTED_LANGS)[number];

// vars supports simple {placeholder} substitution: t('greet', 'Hi {name}', { name: 'Adde' }).
// Values are coerced to strings via String(); booleans/numbers are fine.
// Plurals are NOT handled by t() — use convention keys (.zero/.one/.other)
// and let the caller pick the suffix.
export type TVars = Readonly<Record<string, string | number | boolean | null | undefined>>;

export type I18nContextValue = {
  lang: LangCode;
  setLang: (code: LangCode) => void;
  t: (key: string, fallback?: string, vars?: TVars) => string;
  catalogLoaded: boolean;
};

export const I18nContext = createContext<I18nContextValue | null>(null);
